import { render } from "./Aanspreking.vue?vue&type=template&id=c8292834&scoped=true"
import script from "./Aanspreking.vue?vue&type=script&lang=js"
export * from "./Aanspreking.vue?vue&type=script&lang=js"

import "./Aanspreking.vue?vue&type=style&index=0&id=c8292834&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8292834"]])

export default __exports__